import React, {useState, useEffect, useContext, Fragment, useRef} from 'react'
import {Formik, Form, FieldArray, setNestedObjectValues} from 'formik'
import * as Yup from 'yup'
import Loader from '../../../components/Loader'
import {get, post} from '../../../lib/api'
import {
  getTokenAndUid,
  getNameFromUrl,
  calculateStringMatchScore,
  extractDocuments,
  checkOverseasUser,
  wordCount,
  handleEventLog,
  handlePageLoadEventLog,
  handleNotionOrExternalLink
} from '../../../lib/utils'
import {DropDownSelect, FloatingInput, Input, Upload} from '../../../components/FormikInputs'
import FileIcon from '../../../components/Images/File'
import CheckedIcon from '../../../components/Images/Checked'
import { Box, Text } from '../../../designSystem'
import {AccountContext} from '../../../providers/accountProvider';
import {countryList} from '../../../constants'
import GenericErrorPopup from '../../../components/GenericError'
import DownloadWithoutCircle from '../../../components/Images/DownloadWithoutCircle'
import PlusWithCircleIcon from '../../../components/Images/PlusWithCircle'
import ArrorLeft from '../../../components/Images/ArrowLeft'
import DataModal from './DataModal'
import {
  CheckSampleBtn,
  SectionHeading,
  UploadSubLabel,
  UploadLabel,
  HR,
  RadioIcon,
  ConfirmAndSubmit,
  AgreeCTA,
  CharacterBtn,
  ActionContainer,
  SaveBtn,
  BackBtn,
  ImportantPlotlinesBtn,
  AddMoreCharacterBtn,
  AddMorePlotlinesBtn,
  Container,
  SubSectionTitle,
  InlineInfoText,
  FlexContainer,
  InputContainer,
  FileContainer,
  FilePlaceHolder,
  ProgressDiv,
  ProgressPercent,
  LinearProgress,
  ProgressBar,
  StyledCrossIcon,
  InvalidDetailsDiv,
  HoverActions,
  FileNameDiv,
  FileIconDiv,
  FileDetailsDiv,
  FileName,
  DownloadButton,
  DownloadPdfButton,
  UploadButton,
  SaveButton,
  HelpText,
  RightCrossIcon,
  CheckBox
} from './styles'
import { Popup } from '../../../components/Popup'
import Exclamation from '../../../components/Images/Exclamation'
import { PhoneInput } from '../../../components/FormComponents'


export const FileUploadComponent = ({
                                      readOnly,
                                      isLoading,
                                      progress,
                                      imageUrl,
                                      placeholder,
                                      handleReUpload = () => null,
                                      title,
                                      hasError,
                                      cancelRequest,
                                      privateDownload
                                    }) => {
  const [isProcessing, setIsProcessing] = useState(false)

  const handlePrivateDownload = () => {
    if (!imageUrl) return
    const extension = imageUrl.split('.').pop()
    get('/upload/user_docs', {
      params: {
        base_url: imageUrl,
        is_novel: 1
      }
    }).then(response => {
      const {signed_url: link} = response
      const hiddenElement = document.createElement('a')
      hiddenElement.href = link
      hiddenElement.target = '_blank'
      hiddenElement.download = 'doc.' + extension
      hiddenElement.click()
      setIsProcessing(false)
    })
  }
  return (
    <>
      {!imageUrl && !isLoading && (
        <FileContainer hasError={hasError}>
          {placeholder && <FilePlaceHolder>{placeholder}</FilePlaceHolder>}
        </FileContainer>
      )}
      {isLoading && (
        <ProgressDiv>
          <LinearProgress>
            <ProgressBar value={progress >= 100 ? 100 : progress}/>
          </LinearProgress>
          <ProgressPercent>
            {(progress >= 100 ? '100' : progress.toFixed(0)) + '% Uploaded'}
          </ProgressPercent>
          <StyledCrossIcon onClick={cancelRequest}/>
        </ProgressDiv>
      )}
      {imageUrl && !isLoading && (
        <FileNameDiv>
          <FileIconDiv>
            <FileIcon/>
          </FileIconDiv>
          <FileDetailsDiv>
            <FileName>{getNameFromUrl(imageUrl, title)}</FileName>
          </FileDetailsDiv>
          <HoverActions>
            {!privateDownload && <DownloadButton href={imageUrl} download type="button">
              Download
            </DownloadButton>}
            {privateDownload && <DownloadPdfButton onClick={handlePrivateDownload} type="button">
              {isProcessing ? 'Downloading...' : 'Download'}
            </DownloadPdfButton>}
            {!readOnly && <UploadButton type="button" onClick={handleReUpload}>
              Upload
            </UploadButton>}
          </HoverActions>
        </FileNameDiv>
      )}
    </>
  )
}

const Step = ({setCurrentStep, id, handleContractDetails, resetSteps, isNovelContract = false, showTerms, reappliedProgramId, book_name, book_language }) => {
  const [data, setData] = useState(null)
  const [guardianData,setGuardianData] = useState(null)
  const [authorBankData,updateAuthorBankData] = useState(null)
  const [rowData, setRowData] = useState(null)
  const [addressData, setAddressData] = useState(null)
  const [novelData, setNovelData] = useState(null);
  const [isAgreed, setIsAgreed] = useState(false)
  const [focusFields, setFocusFields] = useState({'email': true})
  const [govtUrl, setGovtUrl] = useState({})
  const [cancelCheque, setCancelCheque] = useState({})
  const {user, onUpdateUser} = useContext(AccountContext)
  const [amount, setAmount] = useState("");
  const isUserIndian = !checkOverseasUser(user)
  const isUserFromUS = user?.location === 'US' || novelData?.is_novel === 2
  const [estimatedRewards, updateEstimatedRewards] = useState(null);
  const [apiError,toggleApiError] = useState(false)
  const [isPlotlinesFormVisible, setIsPlotlinesFormVisible]  = useState(false)         
  const [characterFormParams, setCharacterFormParams] = useState({visible: false, isProtagonist: false, index: -1})
  const [showSampleData, setShowSampleData] = useState(false)
  const [sampleData, setSampleData] = useState({url:"", heading:""})
  const [optionChosenAfterNameMismatch,updateOptionChosenAfterNameMismatch] = useState('')
  const [nameMismatchPopup,toggleNameMismatchPopup] = useState(false)
  const [guardianPhoneNo, updateGuardianPhoneNo] = useState('')
  const [guardianPhoneErr,setGuardianPhoneErr] = useState('')
  const saveButtonRef = useRef(null)
  const formatCurrency = cur => {
    return (Math.round(cur * 100) / 100).toLocaleString()
  }

  const estimateRewardsCalc = words => {
    words = Number(words);
    if (!words || words < 100000) {
      updateEstimatedRewards(null)
      return
    }
    let minReward = 0, maxReward, sign;
    if (isUserIndian) {
      sign = "₹";
      if (words >= 500000) {
        minReward = 25000;
      } else if (words >= 350000) {
        minReward = 10000;
      } else if (words >= 250000) {
        minReward = 5000;
      }
      maxReward = minReward;
      minReward += Math.floor(((words - 30000) * 0.04) + 3000);
      maxReward += Math.floor(((words - 30000) * 0.12) + 3000);
    } else if(isUserFromUS){
      sign = "$";
      if (words >= 450000) {
        minReward = 0.02*(words-450000);
      } else if (words >= 350000) {
        minReward = 0.015*(words-350000);
      } else if (words >= 250000) {
        minReward = 0.01*(words-250000);
      }
      maxReward = minReward;
      minReward += Math.ceil(((words - 30000) * 0.012) + 1000);
      maxReward += Math.ceil(((words - 30000) * 0.02223) + 1000);
    }
    minReward = formatCurrency(minReward);
    maxReward = formatCurrency(maxReward)
    updateEstimatedRewards(`Estimated rewards : min ${sign}${minReward} - max ${sign}${maxReward} based on writing frequency & story quality.`);
  }

  const submitBookPlotlinesHandler = (validateField, setFieldTouched, setErrors) => {
    validateField("book_plotlines")
    setFieldTouched('book_plotlines', true, true).then( errors => {
      if(errors?.book_plotlines?.length > 0 ) return 
      else {
        setIsPlotlinesFormVisible(false)        
        setErrors({})
      }
    })    
  }

  const submitBookCharactersHandler = (validateField, setFieldTouched, setErrors) => {
    validateField("book_characters")
    setFieldTouched('book_characters', true, true).then( errors => {
        if(errors?.book_characters?.length > 0 && Object.keys(errors?.book_characters?.at(characterFormParams?.index) ? errors?.book_characters?.at(characterFormParams?.index) : {}).length > 0) return
        else {
          setCharacterFormParams(false)
          setErrors({})
        }
    })
  }

  const handleGuardianPhoneChange = (text) => {
    if(!text.startsWith('91')){
      updateGuardianPhoneNo('91')
    }else{
      updateGuardianPhoneNo(text)
    }
    setGuardianPhoneErr('')
  }

  const validateGuardianPhone = () =>{
    const guardianNumber = guardianPhoneNo?.slice(2)
    const authorPhoneNo = (user.phone_number)?.slice(3)
    if(guardianNumber === authorPhoneNo){
      setGuardianPhoneErr("Can't be the same as the creator’s registration number")
      return true
    }
    if(!((/^(\+91[\-\s]?)?[0]?(91)?[789]\d{9}$/).test('+91'+ guardianNumber))){
      setGuardianPhoneErr('Required')
      return true
    }
    return false
  }

  useEffect(() => { 
    setAmount(((user?.login_type !== "email_login") || (user?.login_type === "email_login" && user?.location === 'IN') ? "Rs 5000" : "$300"))
    const {uid} = getTokenAndUid()
    handlePageLoadEventLog("writer_benefit_form")
    if (checkOverseasUser(user)) {
      get(`/user_api/row_creator/${uid}/?is_novel=1`).then(response => {
        setRowData(response?.id ? response : {})
        if (response?.id) {
          const docs = extractDocuments(response.documents)
          setCancelCheque(docs[0])
          setGovtUrl(docs[1])
        }
      })
    } else {
      get(`/user_api/user_bank_accounts/${uid}/?is_novel=1`).then(res => {
        let index = res.result?.findIndex((data) => data?.is_guardian_account === 1)
        index >= 0 && setGuardianData(res.result?.[index] || {})
        index = res.result?.findIndex((data) => !data?.is_guardian_account)
        index >= 0 && setData(res.result?.[index])
        if(res?.result?.length <= 0 || index === -1) setData({})
      })
    }
    get(`/user_api/user_addresses/${uid}/?is_novel=1`).then(response => {
      setAddressData(response.result[0] || {})
    })
    get('/content_api/book.novel_details', {
      params: {
        book_id: id,
        is_novel: 1,
        view: 'writers'
      }
    }).then(response => {
      setNovelData(response.results)
    })
  }, [])

  useEffect(()=>{
    if('IntersectionObserver' in window){
      const observer = new IntersectionObserver(([entry]) => {
        if(entry.isIntersecting) handleEventLog("home", "button_view", {module_name: +getComputedStyle(saveButtonRef.current).opacity === 1 ? "apply_now" : "disabled_apply_now", entity_id: id, entity_type: "show"})
      },{
        root:null,
        rootMargin:"0px",
        threshold:1
      })
      if(saveButtonRef.current) observer.observe(saveButtonRef.current)  
      return () => observer.disconnect()
    }
  },[saveButtonRef.current])

  return (!addressData || (isUserIndian ? !data : !rowData)) ? <Loader/> : <Formik
    initialValues={{
      fullname: '',
      email: user['email'] || '',
      guardian_email: guardianData?.guardian_email || '',
      aadhaar_card_no: data?.['aadhaar_card_no'] || '',
      aadhaar_card_url: data?.['aadhaar_card_url'] || '',
      account_name: data?.account_name || rowData?.account_name || '',
      bank_name: data?.bank_name || rowData?.bank_name || '',
      account_no: data?.account_no || rowData?.account_no || '',
      ifsc_code: data?.ifsc_code || '',
      pan_card_no: data?.pan_card_no || '',
      cancelled_cheque_url: data?.cancelled_cheque_url || cancelCheque?.url || '',
      pan_card_url: data?.pan_card_url || '',
      address_1: addressData['address_1'] || '',
      address_2: addressData['address_2'] || '',
      pin_code: addressData['pin_code'] || '',
      city: addressData['city'] || '',
      state: addressData['state'] || '',
      country: addressData['country'] || user.location || '',
      swift_code: rowData?.swift_code || '',
      gov_id_no: rowData?.gov_id_no || '',
      govt_id_url: govtUrl?.url || '',
      book_title: novelData?.book_title || '',
      book_summary: novelData?.book_summary || '',
      book_plotlines: novelData?.book_plotlines || [0,1,2,3,4,5,6,7,8,9].map(id => ({id, details: ""})),
      book_characters: !isUserFromUS &&  novelData?.book_characters || [{id: 0, name:"", characterDetail:"", isProtagonist: true},{id: 1, name:"", characterDetail:"", isProtagonist: false},{id: 2, name:"", characterDetail:"", isProtagonist: false}],
    }}
    enableReinitialize
    validationSchema={Yup.object({
      guardian_email: optionChosenAfterNameMismatch === 'add-guardian' && Yup.string().required('Required').email('Enter valid Email ID').notOneOf([Yup.ref('email')],"Can't be the same as the author’s email id"),
      aadhaar_card_no: optionChosenAfterNameMismatch === 'add-guardian' && Yup.string().required('Required').matches(/^[2-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$/,"Invalid Aadhaar Number"),
      aadhaar_card_url: optionChosenAfterNameMismatch === 'add-guardian' && Yup.string().required('Required'),
      book_title: Yup.string().required('Required'),
      book_words: !isUserFromUS && Yup.number().required('Required').positive().min(100000, 'Novels under the program should plan for at least 100,000 words ').max(99999999,'Maximum 8 digits allowed'),
      email: Yup.string().required('Required').email('Enter valid Email ID'),
      fullname: Yup.string().required('Required').matches(/^[\D]*$/, 'Only Alphabets are  allowed'),
      account_name: Yup.string().required('Required').matches(/^[\D]*$/, 'Only Alphabets are  allowed'),
      bank_name: Yup.string().required('Required'),
      account_no: Yup.string().required('Required').matches(/^\d{9,18}$/, 'Please Enter Valid Account Number'),
      cancelled_cheque_url: Yup.string().required('Required'),
      address_1: Yup.string().required('Required'),
      address_2: Yup.string().required('Required'),
      pin_code: Yup.string().required('Required'),
      city: Yup.string().required('Required').matches(/^[a-zA-Z\s]*$/, 'Only Alphabets are  allowed'),
      state: Yup.string().required('Required').matches(/^[a-zA-Z\s]*$/, 'Only Alphabets are  allowed'),
      country: Yup.string().required('Required'),
      pan_card_no: isUserIndian && Yup.string().required('pan_card_no').matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, "Invalid Pan Card Number"),
      swift_code: !isUserIndian && Yup.string().required('swift_code').matches(/^[A-Za-z0-9]{8,11}$/, "Invalid Swift Code"),
      ifsc_code: isUserIndian && Yup.string().required('ifsc_code').matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, 'Enter Valid IFSC code'),
      gov_id_no: !isUserIndian && Yup.string().required('Required Govt. id number'),
      pan_card_url: isUserIndian && Yup.string().required('pan_card_url'),
      book_summary: Yup.string().required('Required').test('word_count', "Minimum word limit is 200 & Maximum word limit is 500", val => wordCount(val) >= 200 && wordCount(val) <= 500 ),
      // book_plotlines: Yup.array().of(Yup.object({id:Yup.number(), details:Yup.string().required("Required").test('word_count', "Minimum word limit is 30 & Maximum word limit is 100", val => wordCount(val) >= 30 && wordCount(val) <= 100)})),
      book_characters: !isUserFromUS && Yup.array().of(Yup.object({id:Yup.number(), name:Yup.string().required("Required"), characterDetail:Yup.string().required("Required").test('word_count', "Minimum word limit is 10 & Maximum word limit is 30", val => wordCount(val) >= 10 && wordCount(val) <= 30), isProtagonist: Yup.boolean()})),
    })}
    onSubmit={(values, {setSubmitting}) => {     
      if(optionChosenAfterNameMismatch === 'add-guardian' && validateGuardianPhone()){
          setSubmitting(false)
          return
      } 
      if (!isAgreed) {
        setSubmitting(false)
        return
      }
      if(!calculateStringMatchScore(values.fullname,values.account_name) && isUserIndian && optionChosenAfterNameMismatch !== 'add-guardian'){
        const { account_name, bank_name, account_no, ifsc_code,pan_card_no, pan_card_url, cancelled_cheque_url} = values
        updateAuthorBankData({
          account_name, bank_name, account_no, ifsc_code,pan_card_no, pan_card_url, cancelled_cheque_url
        })
        setSubmitting(false)
        updateOptionChosenAfterNameMismatch('')
        toggleNameMismatchPopup(true)
        return
      }
      handleEventLog("home", "button_click", {module_name:"apply_now", entity_id: id, entity_type: "show"})
      const {uid} = getTokenAndUid()
      const {pan_card_url, cancelled_cheque_url, govt_id_url, book_words, ...formValues} = values
      const formDataForProgram = {
        uid,
        entity_type: "book",
        entity_id: id,
        program_type: isUserFromUS ? "writer_benefit_v3_us" : "writer_benefit_v3",
        expected_word_count: Number(book_words),
        book_summary: values?.book_summary,
        book_plotlines:values?.book_plotlines,
        book_characters: values?.book_characters
      }
      if (reappliedProgramId) {
        formDataForProgram['program_id'] = reappliedProgramId
        formDataForProgram['status'] = 'pending'
      }
      let formData = {}

      const {
        address_1,
        address_2,
        pin_code,
        country,
        state,
        city,
        account_name,
        account_no,
        ifsc_code,
        pan_card_no,
        bank_name,
        fullname,
        swift_code,
        gov_id_no,
        guardian_email,
        aadhaar_card_no,
        aadhaar_card_url
      } = values
      formData = {...formData, account_name, account_no, bank_name}
      if (isUserIndian) {
        formData['pan_card_url'] = uid + '/' + pan_card_url.split('/').pop()
        formData['cancelled_cheque_url'] = uid + '/' + cancelled_cheque_url.split('/').pop()
        formData = {...formData, ifsc_code, pan_card_no, account_id: data?.account_id, uid}
      } else {

        let documents = []
        if (cancelCheque?.id) {
          documents = [...documents, {
            'cancelled_cheque_url': {
              id: cancelCheque?.id,
              url: cancelled_cheque_url
            }
          }]
        } else {
          documents = [...documents, {
            'cancelled_cheque_url': {url: cancelled_cheque_url}
          }]
        }


        if (govtUrl?.id) {
          documents = [...documents, {
            'govt_id_url': {
              id: govtUrl?.id,
              url: govt_id_url
            }
          }]
        } else {
          documents = [...documents, {
            'govt_id_url': {url: govt_id_url}
          }]
        }
        formData['documents'] = documents
        formData = {...formData, swift_code, gov_id_no, creator_id: uid}
      }

      if (rowData?.id) {
        formData['id'] = rowData?.id
      }
      var addressPostData = {
        uid, address_1, address_2, pin_code, state, city, address_id: addressData['address_id'], country
      }
      if (isUserIndian) {
        const isStringMatched = calculateStringMatchScore(fullname, account_name)
        var contractData = {
          uid,
          book_id: id,
          author_name: fullname,
          phone_number: (user.phone_number)?.slice(3),
          email: values.email,
          book_language,
          book_name,
          address: {address_1, address_2, pin_code, state, city, country}
        }
        if (!isStringMatched && optionChosenAfterNameMismatch !== 'add-guardian') {
          const contractFormData = {
            status: 'failed',
            reason: 'Author name and account name is not matched and score is less than 50%'
          }
          contractData = {...contractData, ...contractFormData}
        }
        if(optionChosenAfterNameMismatch === 'add-guardian'){
           contractData['account_details']= { aadhaar_card_no }
           contractData['guardian_account_details']= 
            {guardian_email, account_name, account_no, ifsc_code, pan_card_no, bank_name, guardian_phone_number : guardianPhoneNo?.slice(2) || '' } 
        }else{
          contractData['account_details']= 
            {account_name, account_no, ifsc_code, pan_card_no, bank_name}
        }
      }

      if(optionChosenAfterNameMismatch === 'add-guardian'){
        delete formData.account_id
        formData['is_guardian_account'] = 1
        formDataForProgram['is_guardian_flow'] = 1
        formData['guardian_phone_number'] = '+91' + guardianPhoneNo?.slice(2)
        formData['guardian_email'] = values?.guardian_email
        contractData['is_guardian_flow'] = 1
        contractData['status'] = 'undertaker_pending'
        if(guardianData?.account_id){
          formData['account_id'] = guardianData?.account_id
        }
      }else{
        formData['is_guardian_account'] = 0
      }
      let aadharData = { }
      if(optionChosenAfterNameMismatch === 'add-guardian'){
          aadharData = { 
            aadhaar_card_no, 
            aadhaar_card_url, 
            uid,
            ...authorBankData
        }
        if(data?.account_id){
          aadharData['account_id'] = data?.account_id
        }
      }
      if(isUserFromUS){
        delete formDataForProgram?.expected_word_count
        delete formDataForProgram?.book_characters
      }
      delete formDataForProgram?.book_plotlines

      const allPromises = [
        isUserIndian ? post('/user_api/user_bank_accounts/?is_novel=1', {data: formData}) : post(`/user_api/row_creator/?is_novel=${novelData?.is_novel || 1}`, {data: formData}),
        optionChosenAfterNameMismatch === 'add-guardian' && post(`/user_api/user_bank_accounts/?is_novel=${novelData?.is_novel || 1}`, {data: {...aadharData}}),
        post(`/user_api/user.update?is_novel=${novelData?.is_novel || 1}`, {data: {fullname: values['fullname'], email : values['email']}}),
        post(`/user_api/user_addresses/?is_novel=${novelData?.is_novel || 1}`, {data: {...addressPostData}}),
        post(`/content_api/book.creator_ben_prog/?is_novel=${novelData?.is_novel || 1}`, {data: {...formDataForProgram}})
      ]
      Promise.all(allPromises).then(() => {
        if (isNovelContract || (!checkOverseasUser(user) && (book_language === 'english' || book_language === 'tamil' || book_language === 'hindi'))) {
          // post('/contract/?is_novel=1', {data: {...contractData}}).then((res) => {
          //   isNovelContract ?  handleContractDetails(fullname) : setCurrentStep(2)
          //   setSubmitting(false)
          // }).catch((err) => {
          //   isNovelContract ? handleContractDetails(values?.fullname) : setCurrentStep(2);
          //   setSubmitting(false)
          // })
          isNovelContract ? handleContractDetails(values?.fullname) : setCurrentStep(2);
          setSubmitting(false)
        } 
        else if(!isNovelContract) setCurrentStep(2)
        
      })
    }}
  >
    {({isValid, isSubmitting, touched, submitCount, setFieldValue, errors, values, validateField, setErrors, setFieldTouched}) => {
      estimateRewardsCalc(values.book_words);
      return (
        <>
        <GenericErrorPopup 
          show={apiError} 
          onClose={() => toggleApiError(false)}
        />

          <Form>
            {!isPlotlinesFormVisible && !characterFormParams?.visible && <Container>
              <SectionHeading>Application for Writer Benefit Program</SectionHeading>
              <HelpText>
                You will be eligible for payments for signing bonus & monthly daily update bonus rewards once you have
                signed an exclusive contract with us.
              </HelpText>
              <FlexContainer>
                <Box width={["100%", "49%"]} mb={8}>
                  <FloatingInput
                    type="text"
                    name="fullname"
                    label="Author Name"
                    size="lg"
                    autoFocus
                    hasError={submitCount > 0 && errors?.fullname}
                    touched={touched?.fullname}
                    onFocus={() => setFocusFields({...focusFields, 'fullname': true})}
                    onBlur={() => setFocusFields({...focusFields, 'fullname': false})}
                  />
                  {focusFields?.fullname &&
                    <InvalidDetailsDiv value="blue">Please confirm your real name for contract</InvalidDetailsDiv>}
                  {errors?.fullname && <InvalidDetailsDiv value="red">{errors.fullname}</InvalidDetailsDiv>}
                </Box>
                <Box width={["100%", "49%"]} mb={8}>
                  <FloatingInput
                    type="text"
                    name="email"
                    label="Email ID"
                    size="lg"
                    readOnly={user?.login_type === 'email_login'}
                    onFocus={() => setFocusFields({...focusFields, 'email': true})}
                    onBlur={() => setFocusFields({...focusFields, 'email': true})}
                  />
                  {focusFields?.email &&
                    <InvalidDetailsDiv value="blue">Please fill valid/existing email for contract</InvalidDetailsDiv>}
                  {errors?.email &&
                    <InvalidDetailsDiv value="red">{errors.email}</InvalidDetailsDiv>}
                </Box>
              </FlexContainer>
              {optionChosenAfterNameMismatch === 'add-guardian' && 
              <FlexContainer>
                <Box width={["100%", "49%"]} mb={8}>
                  <FloatingInput
                    type="text"
                    name="aadhaar_card_no"
                    label="Aadhar Number"
                    size="lg"
                    hasError={submitCount > 0 && errors?.aadhaar_card_no}
                  />
                  {errors?.aadhaar_card_no &&
                    <InvalidDetailsDiv value="red">{errors.aadhaar_card_no}</InvalidDetailsDiv>}
                </Box>
                <InputContainer>
                  <UploadLabel>Aadhaar Card Document</UploadLabel>
                  <Upload
                    name="aadhaar_card_url"
                    privateDownload
                    hasError={submitCount > 0 && errors['aadhaar_card_url']}
                    hideInputOnValue
                    showProgress
                    saveWithoutCDN={1}
                    cloud_dir_file={getTokenAndUid().uid}
                    placeholder="Drop your doc file here to upload or click to select"
                    renderComp={FileUploadComponent}
                    fileTypeTags="user_doc"
                    accept="application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, application/doc, application/ms-doc, image/jpeg, image/jpg, image/png, application/pdf"
                    extraParams={{
                      title: "Bank-Document"
                    }}
                  />
                </InputContainer>
              </FlexContainer>}
              <Box my={16}>
                <SubSectionTitle>Mailing Address</SubSectionTitle>
                <Box variant="flex" flexDirection={['column', 'row']}>
                  <Box width={["100%", "49%"]} mb={16}>
                    <FloatingInput
                      type="text"
                      name="address_1"
                      label="House No, Apt No, Building No"
                      size="lg"
                      hasError={submitCount > 0 && errors['address_1']}
                    />
                    {errors.address_1 && <InvalidDetailsDiv value="red">{errors.address_1}</InvalidDetailsDiv>}
                  </Box>

                  <Box width={["100%", "49%"]} mb={16}>
                    <FloatingInput
                      type="text"
                      name="address_2"
                      label="Address Line 2"
                      size="lg"
                      hasError={submitCount > 0 && errors['address_2']}
                    />
                    {errors.address_2 && <InvalidDetailsDiv value="red">{errors.address_2}</InvalidDetailsDiv>}
                  </Box>
                </Box>
                <Box variant="flex" flexDirection={['column', 'row']}>
                  <Box width={["100%", "49%"]} mb={16}>
                    <FloatingInput
                      type="number"
                      name="pin_code"
                      label="Pin code"
                      size="lg"
                      hasError={submitCount > 0 && errors['pin_code']}
                    />
                    {errors.pin_code &&
                      <InvalidDetailsDiv value="red">{errors.pin_code || "Field Can't be empty"}</InvalidDetailsDiv>}
                  </Box>
                  <Box width={["100%", "49%"]} mb={16}>
                    <FloatingInput type="text" name="city" label="City" size="lg"
                                  hasError={submitCount > 0 && errors['city']}/>
                    {errors.city && <InvalidDetailsDiv value="red">{errors.city}</InvalidDetailsDiv>}
                  </Box>
                </Box>
                <Box variant="flex" flexDirection={['column', 'row']}>
                  <Box width={["100%", "49%"]} mb={16}>
                    <FloatingInput
                      type="text"
                      name="state"
                      label="State"
                      size="lg"
                      hasError={submitCount > 0 && errors['state']}
                    />
                    {errors.state && <InvalidDetailsDiv value="red">{errors.state}</InvalidDetailsDiv>}
                  </Box>
                  {user.location !== 'US' &&<Box width={["100%", "49%"]} mb={16}>
                    <DropDownSelect
                      name="country"
                      placeholder="Country"
                      selectOptions={countryList.filter((country) => country.name !== 'Global')}
                      idKey="code"
                      nameKey="name"
                      readOnly
                    />
                    {errors.country && <InvalidDetailsDiv value="red">{errors.country}</InvalidDetailsDiv>}
                  </Box>}
                </Box>
              </Box>
              <SubSectionTitle>{optionChosenAfterNameMismatch === 'add-guardian' ? "Your Guardian’s Bank Details" : 'Bank Details'}</SubSectionTitle>
              <InlineInfoText>This is the bank account in which you will recieve your payments</InlineInfoText>
              {optionChosenAfterNameMismatch === 'add-guardian' && 
              <FlexContainer>
                <Box width={["100%", "49%"]} mb={8}>
                  <FloatingInput
                    type="text"
                    name="guardian_email"
                    label="Guardian Email ID"
                    size="lg"
                    hasError={submitCount > 0 && errors['pin_code']}
                    readOnly={user?.login_type === 'email_login'}
                    onFocus={() => setFocusFields({...focusFields, 'guardian_email': true})}
                    onBlur={() => setFocusFields({...focusFields, 'guardian_email': true})}
                  />
                  {errors?.guardian_email &&
                    <InvalidDetailsDiv value="red">{errors.guardian_email}</InvalidDetailsDiv>}
                </Box>
                <Box width={["100%", "49%"]} mb={8}>
                  <PhoneInput 
                    error={guardianPhoneErr}
                    name="guardian_phone_no"
                    disableDropdown
                    onlyCountries={['in']}
                    country={'in'}
                    type="text"
                    value={guardianPhoneNo}
                    onChange={(text) => handleGuardianPhoneChange(text)}
                  />
                  {guardianPhoneErr !== '' &&
                    <InvalidDetailsDiv value="red">{guardianPhoneErr || "Can't be the same as the creator’s registration number"}</InvalidDetailsDiv>}
              
                </Box>
                </FlexContainer>}
              <FlexContainer>
                <Box width={["100%", "49%"]} mb={16}>
                  <FloatingInput
                    type="text"
                    name="account_name"
                    label="Full Name ( Account Owner )"
                    size="lg"
                    hasError = {errors?.account_name}
                    touched={touched?.account_name}
                    autoFocus={optionChosenAfterNameMismatch === 'edit-names'}
                    onFocus={() => setFocusFields({...focusFields, 'account_name': true})}
                    onBlur={() => setFocusFields({...focusFields, 'account_name': false})}
                  />

                  {focusFields?.account_name && optionChosenAfterNameMismatch !== 'add-guardian' &&
                    <InvalidDetailsDiv value="blue">Please confirm the exact name as registered in bank</InvalidDetailsDiv>}
                  {errors.account_name &&
                    <InvalidDetailsDiv value="red">{errors.account_name}</InvalidDetailsDiv>
                  }
                </Box>

                <Box width={["100%", "49%"]} mb={16}>
                  <FloatingInput
                    type="text"
                    name="bank_name"
                    label="Bank Name"
                    size="lg"
                    hasError={submitCount > 0 && errors['bank_name']}
                  />
                  {errors.bank_name &&
                    <InvalidDetailsDiv value="red">{errors.bank_name}</InvalidDetailsDiv>
                  }
                </Box>

              </FlexContainer>

              <FlexContainer>
                <Box width={["100%", "49%"]} mb={16}>
                  <FloatingInput
                    type="text"
                    name="account_no"
                    label="Account Number"
                    size="lg"
                    onFocus={() => setFocusFields({...focusFields, 'account_no': true})}
                    onBlur={() => setFocusFields({...focusFields, 'account_no': false})}
                  />
                  {focusFields?.account_no &&
                    <InvalidDetailsDiv value="blue">Enter the same account number as in Bank Proof
                      Document</InvalidDetailsDiv>}
                  {errors?.account_no &&
                    <InvalidDetailsDiv value="red">{errors.account_no}</InvalidDetailsDiv>
                  }
                </Box>
                {isUserIndian ? <Box width={["100%", "49%"]} mb={16}>
                    <FloatingInput
                      type="text"
                      name="ifsc_code"
                      label="IFSC Code"
                      size="lg"
                    />
                    {errors?.ifsc_code &&
                      <InvalidDetailsDiv value="red">{errors.ifsc_code}</InvalidDetailsDiv>
                    }
                  </Box> :
                  <Box width={["100%", "49%"]} mb={16}>
                    <FloatingInput
                      type="text"
                      name="swift_code"
                      label="SWIFT Code"
                      size="lg"
                    />
                    {errors?.swift_code &&
                      <InvalidDetailsDiv value="red">{errors.swift_code}</InvalidDetailsDiv>
                    }
                  </Box>}
              </FlexContainer>
              {isUserIndian ? <Box variant="flex" flexDirection={['column', 'row']}>
                <Box width={["100%", "49%"]} mb={16}>
                  <FloatingInput
                    type="text"
                    name="pan_card_no"
                    label="Pan Card Number"
                    size="lg"
                    hasError={submitCount > 0 && errors['pan_card_no']}
                  />
                  {errors.pan_card_no &&
                    <InvalidDetailsDiv value="red">{errors.pan_card_no}</InvalidDetailsDiv>
                  }
                </Box>
              </Box> : <Box variant="flex" flexDirection={['column', 'row']}>
                <Box width={["100%", "49%"]} mb={16}>
                  <FloatingInput
                    type="text"
                    name="gov_id_no"
                    label="Govt issued Identification card Number"
                    size="lg"
                    hasError={submitCount > 0 && errors['gov_id_no']}
                  />
                  {errors.gov_id_no &&
                    <InvalidDetailsDiv value="red">{errors.gov_id_no}</InvalidDetailsDiv>
                  }
                </Box>
              </Box>}

              <SubSectionTitle>{optionChosenAfterNameMismatch === 'add-guardian' ? "Guardian's Documents" : 'Documents'}</SubSectionTitle>
              <InlineInfoText>These documents are required to verify the bank details & tax purpose</InlineInfoText>
              <FlexContainer>
                <InputContainer>
                  <UploadLabel>Cancelled Cheque/ Passbook/Bank statement</UploadLabel>
                  <UploadSubLabel>Submit your banking proof:Cancelled Cheque/ Passbook/Bank statement to confirm your bank
                    details</UploadSubLabel>
                  <Upload
                    // label="Cancelled Cheqeue"
                    name="cancelled_cheque_url"
                    privateDownload
                    hasError={submitCount > 0 && errors['cancelled_cheque_url']}
                    hideInputOnValue
                    showProgress
                    saveWithoutCDN={1}
                    cloud_dir_file={getTokenAndUid().uid}
                    placeholder="Drop your doc file here to upload or click to select"
                    renderComp={FileUploadComponent}
                    fileTypeTags="user_doc"
                    accept="application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, application/doc, application/ms-doc, image/jpeg, image/jpg, image/png, application/pdf"
                    extraParams={{
                      title: "Bank-Document"
                    }}
                  />
                </InputContainer>
                {isUserIndian ? <InputContainer>
                    <UploadLabel>Pan Card</UploadLabel>
                    <UploadSubLabel>Pan card is required for tax purposes, if you do not provide the pan card, 20% tax will be
                      deducted</UploadSubLabel>
                    <Upload
                      // label="Pan Card"
                      name="pan_card_url"
                      privateDownload
                      hasError={submitCount > 0 && errors['pan_card_url']}
                      hideInputOnValue
                      showProgress
                      saveWithoutCDN={1}
                      cloud_dir_file={getTokenAndUid().uid}
                      placeholder="Drop your doc file here to upload or click to select"
                      renderComp={FileUploadComponent}
                      fileTypeTags="user_doc"
                      accept="application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, application/doc, application/ms-doc, image/jpeg, image/jpg, image/png, application/pdf"
                      extraParams={{
                        title: "Pan Card",
                      }}
                    />
                  </InputContainer> :
                  <InputContainer>
                    <UploadLabel>Govt issued Identification card</UploadLabel>
                    <UploadSubLabel>This info is required for tax purposes & verification purpose</UploadSubLabel>
                    <Upload
                      // label="Pan Card"
                      name="govt_id_url"
                      privateDownload
                      hasError={submitCount > 0 && errors['govt_id_url']}
                      hideInputOnValue
                      showProgress
                      saveWithoutCDN={1}
                      cloud_dir_file={getTokenAndUid().uid}
                      placeholder="Drop your doc file here to upload or click to select"
                      renderComp={FileUploadComponent}
                      fileTypeTags="user_doc"
                      accept="application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, application/doc, application/ms-doc, image/jpeg, image/jpg, image/png, application/pdf"
                      extraParams={{
                        title: "Govt ID",
                      }}
                    />
                  </InputContainer>}
              </FlexContainer>
              <Box mt={20}>
                <SubSectionTitle>Book Information</SubSectionTitle>
                <InlineInfoText>Book Info. for which the application has been submitted.</InlineInfoText>
              </Box>
              <FlexContainer>
                <Box width={["100%", "49%"]} mb={8}>
                  <FloatingInput
                    type="text"
                    name="book_title"
                    label=" "
                    size="lg"
                    readOnly
                  />
                  {errors?.book_title && <InvalidDetailsDiv value="red">{errors.book_title}</InvalidDetailsDiv>}
                </Box>
                {!isUserFromUS && <Box width={["100%", "49%"]} mb={8}>
                  <FloatingInput
                    type="number"
                    name="book_words"
                    label="Total estimated number of words"
                    size="lg"
                    hasError={errors['book_words']}
                    onFocus={() => setFocusFields({...focusFields, 'book_words': true})}
                    onBlur={() => setFocusFields({...focusFields, 'book_words': false})}
                  />
                  {(focusFields.book_words && !estimatedRewards) && !errors?.book_words &&
                    <InvalidDetailsDiv value="blue">Share how long you are planning your novel for</InvalidDetailsDiv>}
                  {(!focusFields.book_words || estimatedRewards) && !errors?.book_words &&
                    <InvalidDetailsDiv value="blue">{estimatedRewards}</InvalidDetailsDiv>}
                {(errors?.book_words) &&
                    <InvalidDetailsDiv value="red">{errors.book_words}</InvalidDetailsDiv>}
                </Box>}
              </FlexContainer>
              <Box width={["100%", "100%"]} mb={8}>
                <Input
                  type="text"
                  name="book_summary"
                  label="Summary of the Story"
                  size="lg"
                  asTextArea
                  placeholder="This should be a brief outline what the story is about? (Min word count is 200 words)"
                  hasError={errors?.book_summary}
                />
                {errors?.book_summary && <InvalidDetailsDiv value="red">{errors.book_summary}</InvalidDetailsDiv>}
                {book_language === "hindi" && <CheckSampleBtn onClick={() =>  {setShowSampleData(true); setSampleData({heading:"Sample Story Summary", url:"https://radiolycontent.s3.ap-southeast-1.amazonaws.com/books/writers/a2a0a875414049474f9f56ea808b8bc5b0ae1bb2.pdf"})}}>Check sample summary <DownloadWithoutCircle width="12" height="12"/></CheckSampleBtn>}
                {showSampleData && <DataModal onClose={() => {setShowSampleData(false); setSampleData({url:"", heading:""})}} url={sampleData?.url} heading={sampleData?.heading} />}
              </Box>
              {/* <Box width={["100%", "100%"]} mb={8}>
                <ImportantPlotlinesBtn onClick={() => {setIsPlotlinesFormVisible(true); handleEventLog("home","button_click",{module_name:"Important_Plotlines", entity_id: id, entity_type: "show"})}} hasError={errors?.book_plotlines?.length > 0} >
                  <h4>Important Plot Lines</h4>
                  {!values?.book_plotlines[0]?.details && <p>It should include the sequence of the main events that make up a story. Different story arcs in each plotline.</p>}
                  {values?.book_plotlines[0]?.details && <p>Plot Line 1: {values?.book_plotlines[0]?.details}</p>}
                </ImportantPlotlinesBtn>
                {errors?.book_plotlines?.length > 0 && <InvalidDetailsDiv value="red">{errors?.book_plotlines.find(p => p !== undefined)?.details}</InvalidDetailsDiv>}
                {book_language === "hindi" && <CheckSampleBtn onClick={() =>  {setShowSampleData(true); setSampleData({heading:"Sample Story Plotlines", url:"https://radiolycontent.s3.ap-southeast-1.amazonaws.com/books/writers/f74051d668ae8e563ecfb14987cbdb6f78c5a407.pdf"})}}>Check sample plotlines <DownloadWithoutCircle width="12" height="12"/></CheckSampleBtn>}
              </Box> */}
              {!isUserFromUS && <Box mt={20}>
                <SubSectionTitle>Character Brief</SubSectionTitle>
                <InlineInfoText>Protagonist and other main characters</InlineInfoText>
              </Box>}
              {!isUserFromUS && <FieldArray name="book_characters" render={(bookCharacters) => {
                const bookCharactersArray = bookCharacters?.form?.values?.book_characters
                if(bookCharactersArray.length < 3){
                  (bookCharactersArray.length === 1 ? [1,2] : [2]).forEach(key => {
                    bookCharactersArray.push({id: key, name:"", characterDetail:"", isProtagonist: key === 0 ? true : false})
                  })
                }
                const isAddMoreBtnEnabled = bookCharactersArray.length < 6
                return (
                  <>
                    {bookCharactersArray.map((character, index) => {
                      return (
                      <Box width={["100%", "100%"]} mb={8} key={index}>
                        <CharacterBtn 
                        onClick={() => {setCharacterFormParams({visible: true, isProtagonist: character.isProtagonist ? true : false, index }); handleEventLog("home","button_click",{module_name:character.isProtagonist ? "Protagonist" : "Main_Character", entity_id: id, entity_type: "show"})}} 
                        hasError={errors?.book_characters?.length > 0 && (errors?.book_characters?.at(index)?.name || errors?.book_characters?.at(index)?.characterDetail)}
                        >
                        <h4>{character.isProtagonist ? "Protagonist Name" : "Character Name"}</h4>
                        {character.characterDetail && <p>{character.characterDetail}</p>}
                        {!character.characterDetail && <p>Character Details <span>(Minimum 10 words to describe it)</span></p>}
                        </CharacterBtn>
                        {errors?.book_characters?.length > 0 && (errors?.book_characters?.at(index)?.name || errors?.book_characters?.at(index)?.characterDetail) && <InvalidDetailsDiv value="red">{(errors?.book_characters?.at(index)?.name || errors?.book_characters?.at(index)?.characterDetail)}</InvalidDetailsDiv>}
                      </Box>)
                    })}
                    <Box width={["100%", "100%"]} mb={8} mt={8}>
                      <AddMoreCharacterBtn disabled={!isAddMoreBtnEnabled} onClick={() => {bookCharacters.push({id:bookCharactersArray.length, name:"", characterDetail:"", isProtagonist: false}); handleEventLog("home","button_click",{module_name:"Add_More_Characters", entity_id: id, entity_type: "show"})}}><PlusWithCircleIcon /> Add next character</AddMoreCharacterBtn>
                      {book_language === "hindi" && <CheckSampleBtn onClick={() =>  {setShowSampleData(true); setSampleData({heading:"Sample Story Characters", url:"https://radiolycontent.s3.ap-southeast-1.amazonaws.com/books/writers/22b0d360edf5e1a3ed815bad583a499a12cb845b.pdf"})}}>Check sample character detail <DownloadWithoutCircle width="12" height="12"/></CheckSampleBtn>}
                    </Box>
                  </>
                )
              }}/>}
              <HR/>
              <ConfirmAndSubmit>
                <AgreeCTA active={isAgreed}>
                  <RadioIcon active={isAgreed} onClick={() => setIsAgreed(!isAgreed)}>
                    <CheckedIcon/>
                  </RadioIcon>
                  <span>
                    I agree to the <span onClick={() => isUserFromUS ? handleNotionOrExternalLink('https://pocketnovel.notion.site/pocketnovel/Pocket-Novel-Content-and-Community-Guidelines-2cc85c9d716747e2b0d103e3d5a3b07a') : showTerms()}>terms and conditions</span> and confirm that this is my original novel and is not published on any other online/offline platform
                    </span>
                </AgreeCTA>
                {!isSubmitting && <SaveButton ref={saveButtonRef} type="submit" isValid={isValid && isAgreed}>
                  Submit Application
                </SaveButton>}
                {isSubmitting && <SaveButton type="button" isValid={isValid && isAgreed}>
                  <Loader invertColor inline size="sm"/>
                </SaveButton>}
              </ConfirmAndSubmit>
            </Container>}
            {isPlotlinesFormVisible && <Container>
              <BackBtn onClick={() => setIsPlotlinesFormVisible(false)}><ArrorLeft /></BackBtn>
              <div>
                <FieldArray name="book_plotlines" render={ (bookPlotlines) => {
                 const bookPlotlinesArray = bookPlotlines?.form?.values?.book_plotlines
                  const isAddMoreBtnEnabled = bookPlotlinesArray.length < 20
                    return (
                      <>
                        {bookPlotlinesArray.map((_,index) => 
                        (<Fragment key={index}>
                          <Input
                            type="text"
                            name={`book_plotlines[${index}].details`}
                            label={`Plot Line ${index+1}`}
                            size="lg"
                            asTextArea
                            mb={8}
                            hasError={errors?.book_plotlines?.length > 0 && errors?.book_plotlines?.at(index)?.details}
                          />
                          {errors?.book_plotlines?.length > 0 && errors?.book_plotlines[index]?.details && <InvalidDetailsDiv value="red">{errors?.book_plotlines[index]?.details}</InvalidDetailsDiv>}
                        </Fragment>))}
                        <ActionContainer>
                          <AddMorePlotlinesBtn disabled={!isAddMoreBtnEnabled} onClick={() => {bookPlotlines.push({id:bookPlotlinesArray.length,details:""}); handleEventLog("home","button_click",{module_name:"Add_More_Plotline", entity_id: id, entity_type: "show"})}}><PlusWithCircleIcon /> Add more plot lines</AddMorePlotlinesBtn>
                          <SaveBtn isValid={!errors?.book_plotlines} onClick={() => submitBookPlotlinesHandler(validateField, setFieldTouched, setErrors)}>Save</SaveBtn>
                        </ActionContainer>
                      </>
                    )
                }} />
              </div>
              </Container>}
              <Popup
                show={nameMismatchPopup}
                close={() => toggleNameMismatchPopup(false)}
                renderActions={
                  <SaveBtn 
                    isValid={optionChosenAfterNameMismatch !== ''}
                    onClick={() => {
                      window.scrollTo(0,0)
                      if(optionChosenAfterNameMismatch === 'edit-names'){
                        setFieldValue('account_name', '', false)
                        setFieldValue('fullname', '', false)
                        setErrors({'account_name' : 'Author Name & Bank Account holder’s Name should to be the same.','fullname' : 'Author Name & Bank Account holder’s Name should to be the same.'})
                      }else{
                        setFieldValue('account_name', guardianData?.account_name || '', false)
                        setFieldValue('bank_name', guardianData?.bank_name || '', false)
                        setFieldValue('account_no', guardianData?.account_no || '', false)
                        setFieldValue('ifsc_code', guardianData?.ifsc_code || '', false)
                        setFieldValue('pan_card_no', guardianData?.pan_card_no || '', false)
                        setFieldValue('pan_card_url', guardianData?.pan_card_url || '', false)
                        setFieldValue('cancelled_cheque_url', guardianData?.cancelled_cheque_url || '', false)
                        updateGuardianPhoneNo(guardianData?.guardian_phone_number?.slice(1) || '')
                        !guardianData?.guardian_phone_number && setGuardianPhoneErr('Required')
                      }
                      toggleNameMismatchPopup(false)
                    }}
                  >
                    Submit
                  </SaveBtn>
                }
              >
                  <>
                    <RightCrossIcon onClick={() => toggleNameMismatchPopup(false)}/>
                    <Box display="flex" alignItems="center">
                        <Exclamation color="red"/>
                        <Text variant="title" ml={8}>Bank Details and Author Info mismatched</Text>
                    </Box>
                    <Box my={16} ml={16}>
                      <Box display="flex" alignItems="center">
                        <CheckBox active={optionChosenAfterNameMismatch === 'edit-names'} onClick={() => updateOptionChosenAfterNameMismatch('edit-names')}><CheckedIcon/></CheckBox>
                        <Text variant="subHeading" ml={8}>I have my own bank and pan detail, I will correct the submitted detail.</Text>
                      </Box>
                      <Box display="flex" alignItems="center" mt={8}>
                      <CheckBox active={optionChosenAfterNameMismatch === 'add-guardian'} onClick={() => updateOptionChosenAfterNameMismatch('add-guardian')}><CheckedIcon/></CheckBox>
                        <Text variant="subHeading" ml={8}>I don’t have Bank and Pan  info, Please consider my guardian’s info</Text>
                      </Box>
                    </Box>
                  </>
              </Popup>
            {characterFormParams?.visible && <Container>
              <BackBtn onClick={() => {setCharacterFormParams({visible: false, isProtagonist: false, index: -1})}}><ArrorLeft /></BackBtn>
              <div>
                <Box width={["100%", "100%"]} mb={16} mt={24}>
                  <FloatingInput
                    type="text"
                    name={`book_characters[${characterFormParams?.index}].name`}
                    label={characterFormParams?.isProtagonist ? "Protagonist Name" : "Character Name"}
                    size="lg"
                    hasError={errors?.book_characters?.length > 0 && errors?.book_characters?.at(characterFormParams?.index)?.name}
                  />
                  {errors?.book_characters?.length && errors?.book_characters?.at(characterFormParams?.index)?.name && <InvalidDetailsDiv value="red">{errors?.book_characters?.at(characterFormParams?.index)?.name}</InvalidDetailsDiv>}
                </Box>
                <Box width={["100%", "100%"]} mb={16}>
                  <Input
                    type="text"
                    name={`book_characters[${characterFormParams?.index}].characterDetail`}
                    label="Character Detail"
                    size="lg"
                    asTextArea
                    hasError={errors?.book_characters?.length > 0 && errors?.book_characters?.at(characterFormParams?.index)?.characterDetail}
                  />
                  {errors?.book_characters?.length && errors?.book_characters?.at(characterFormParams?.index)?.characterDetail && <InvalidDetailsDiv value="red">{errors?.book_characters?.at(characterFormParams?.index)?.characterDetail}</InvalidDetailsDiv>}
                </Box>
                <Box width={["100%", "100%"]} mt={24}>
                  <SaveBtn isValid={!(errors?.book_characters?.length > 0 && errors?.book_characters?.at(characterFormParams?.index)?.characterDetail)} onClick={() => submitBookCharactersHandler(validateField, setFieldTouched, setErrors)}>Save</SaveBtn>
                </Box>
              </div>
              </Container>}
          </Form>
        </>)
    }}
  </Formik>
}

export default Step
